import React, {useEffect, useRef, useState} from "react";

type DropdownOption = {
    label: string;
    href: string;
};

type WhatsappButtonProps = {
    options: DropdownOption[];
};

const WhatsappButton: React.FC<WhatsappButtonProps> = ({options}) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block" ref={dropdownRef}>
            <button
                className="flex items-center gap-2 bg-green-700 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
                onClick={() => setOpen((prev) => !prev)}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    className="w-5 h-5 fill-current"
                >
                    <path
                        d="M16.001 3C8.821 3 3 8.821 3 16c0 2.533.744 4.997 2.152 7.104L3 29l5.999-2.094A12.938 12.938 0 0016.001 29C23.18 29 29 23.179 29 16S23.18 3 16.001 3zm0 23.5a10.42 10.42 0 01-5.302-1.447l-.379-.224-3.56 1.243 1.17-3.676-.247-.387A10.425 10.425 0 015.5 16C5.5 10.201 10.201 5.5 16.001 5.5 21.799 5.5 26.5 10.201 26.5 16c0 5.798-4.701 10.5-10.499 10.5zm5.757-7.828c-.315-.158-1.863-.92-2.152-1.025-.289-.105-.5-.158-.71.158-.21.315-.815 1.025-.999 1.235-.184.21-.368.237-.684.079-.315-.158-1.33-.49-2.533-1.563-.936-.835-1.568-1.868-1.752-2.183-.184-.315-.02-.486.138-.644.142-.141.315-.368.473-.552.158-.184.21-.315.315-.526.105-.21.053-.394-.026-.552-.079-.158-.71-1.71-.973-2.341-.256-.615-.516-.532-.71-.542l-.605-.01c-.21 0-.552.079-.842.394-.289.315-1.104 1.078-1.104 2.63 0 1.551 1.13 3.05 1.288 3.261.158.21 2.225 3.398 5.392 4.764.754.326 1.342.52 1.801.665.757.241 1.447.207 1.992.126.607-.09 1.863-.762 2.126-1.499.263-.736.263-1.367.184-1.499-.079-.131-.289-.21-.605-.368z"/>
                </svg>

                <span>Whatsapp</span>
            </button>

            {open && (
                <div
                    className="absolute mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden">
                    {options.map((option) => (
                        <a
                            key={option.href}
                            href={option.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block px-4 py-2 hover:bg-gray-100 transition text-gray-700"
                            onClick={() => setOpen(false)}
                        >
                            {option.label}
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

export default WhatsappButton;